import React from 'react';
import HeroSection from '../homepage/HeroSection';
import JourneySection from '../homepage/JourneySection';
import ServicesShowcase from '../homepage/ServicesShowcase';
import ClientsPreview from '../homepage/ClientsPreview';
import FinalCTA from '../homepage/FinalCTA';
import PageProgressNavigator from '../components/PageProgressNavigator';
import SectionTransition from '../components/SectionTransition';

const Home = ({ splashState }) => (
  <main className="home-page">
    {/* Floating section progress dots — visible on desktop */}
    <PageProgressNavigator />

    {/* ── 1. Hero ── */}
    <HeroSection splashState={splashState} />

    <SectionTransition
      nextSection="journey"
      message="Discover how we work"
      variant="light"
    />

    {/* ── 2. Customer Journey (How It Works) ── */}
    <JourneySection />

    <SectionTransition
      nextSection="services"
      message="Explore our services"
      cta="View All Services"
      route="/ServicePage"
      variant="light"
    />

    {/* ── 4. Services Showcase ── */}
    <ServicesShowcase />

    <SectionTransition
      nextSection="clients"
      message="See who trusts us"
      cta="All Clients"
      route="/Client"
      variant="dark"
    />

    {/* ── 5. Clients Preview ── */}
    <ClientsPreview />

    <SectionTransition
      nextSection="cta"
      message="Ready to get started?"
      variant="light"
    />

    {/* ── 6. Final CTA ── */}
    <FinalCTA />
  </main>
);

export default Home;
